import React, { useEffect, useState } from "react";
import { Avatar, Button, Card, Col, Popconfirm, Descriptions, Row, Space } from "antd";
import { ReactComponent as CalenderSvg } from "../../../../assets/images/description/calendar.svg";
import { ReactComponent as DeleteSvg } from "../../../../assets/images/action/deleteWhite.svg";
import { ReactComponent as PersonSvg } from "../../../../assets/images/description/person.svg";
import { ReactComponent as VideoSvg } from "../../../../assets/images/description/Videos.svg";
import { UserOutlined } from "@ant-design/icons";
import { ArrowLeftOutlined } from "@ant-design/icons";

import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { deleteCelebrityCategory, viewCelebrityCategory } from "../../../../redux/reducer/CelebrityCategorySlice";
import dayjs from "dayjs";
import { imageUrl } from "../../../../constants/ApiConstant";
import ContentScalaton from "../../../../components/scalaton/ContentScalaton";
// Breakpoints
const descriptions_breakpoint = {
  xxl: 4,
  xl: 4,
  lg: 3,
  md: 3,
  sm: 2,
  xs: 1,
};
const ViewCelebrityDetails = () => {
  const navigate = useNavigate();

  useEffect(()=>{
    // viewCelebrityCategory 
  })




  const dispatch = useDispatch();
  const location = useLocation();

  const {viewCategory, viewCategoryLoading} = useSelector((prev) => prev?.celebrityCategory)
  
  const celebrityData = location.state?.celebrityData;

  useEffect(() => {
    
    if (celebrityData) {
      dispatch(viewCelebrityCategory(celebrityData?.id));
    }
  }, [dispatch, celebrityData]);


  const handleEdit = (data) => {
    if(data){
      navigate('/manage-celebrity/edit-celebrity', { state: { editData: data } } )
    }

}

const handleDelete = async (id) => {
  try{
   const data = await dispatch(deleteCelebrityCategory(id))

   if(data?.type === "celebrityCategory/delete/fulfilled"){
    navigate('/manage-celebrity')
   }
  }catch(err){
    console.log(err)
  }
} 



  const data = [];
  const basicInfo_details = [
    {
      key: "1",
      label: (
        <>
          <PersonSvg /> Celebrity Name
        </>
      ),
      children: viewCategory?.name_en ?? "user",
      span: 2,
    },
    {
      key: "2",
      label: (
        <>
          <CalenderSvg /> Date Added
        </>
      ),
      children: dayjs(viewCategory?.created_at).format("MM-DD-YYYY") ?? "user",
    },
   
  ];
  return (
    <>
      <div className="viewTenant">
        <div className="tableHeading"><ArrowLeftOutlined onClick={() => navigate(-1)} style={{ fontSize: "18px",  marginRight: "10px" }} />View Celebrity Details</div>
        <Space>
        <Popconfirm
          title={<span style={{ fontWeight: 600, fontSize: '16px' }}>Delete Celebrity?</span>}
          description={<span style={{ color: '#999' }}>This action cannot be undone.</span>}
          onConfirm={() => handleDelete(celebrityData?.id)}
          okText="Yes, Delete"
          cancelText="Cancel"
          okButtonProps={{ danger: true, style: { borderRadius: 6 } }}
          cancelButtonProps={{ style: { borderRadius: 6 } }}
          placement="topRight"
          overlayStyle={{ width: 300 }}
        >
  <Button
    type="primary"
    danger
    icon={<DeleteSvg />}
    className="delete"
    loading={false}
  >
    Delete
  </Button>
</Popconfirm>
          <Button type="primary" onClick={() => handleEdit(celebrityData)}>
            Edit Details
          </Button>
        </Space>
      </div>
      <Card>
        {viewCategoryLoading ? <ContentScalaton /> :  
        <Row gutter={[16, 16]}>
          <Col xs={24} md={18}>
            <div className="customDescription">
              <Descriptions
                className="custom_descriptions"
                layout="vertical"
                items={basicInfo_details}
                size="small"
                column={{ xs: 1, sm: 2, md: 3 }}
              />
            </div>
          </Col>

          {/* Right Column (50%) - Podcast Image */}
          <Col xs={24} md={6} className="podcast-image-container">
            {/* <Avatar
              size={120}
              icon={<UserOutlined />}
              alt="User Img"
              style={{
                backgroundColor: "#45AE51",
                color: "#fff",
                border: "2px solid #fff",
                boxShadow: "0px 1px 2px rgba(0,0,0,0.2)",
              }}
            /> */}
             <Avatar
                    size={120}
                    src={viewCategory?.image_url ? `${process.env.REACT_APP_IMAGE_URL}/${viewCategory?.image_url}` : undefined} // Use the correct base URL
                    icon={!viewCategory?.image_url ? <UserOutlined /> : undefined}
                    alt="User Img"
                    style={{
                      backgroundColor: viewCategory?.image_url ? "transparent" : "#45AE51", // If logo exists, remove background color
                      color: "#fff",
                      border: "2px solid #fff",
                      boxShadow: "0px 1px 2px rgba(0,0,0,0.2)",
                    }}
                  />
          </Col>
        </Row>
        }
      </Card>
    </>
  );
};

export default ViewCelebrityDetails;
